export default __webpack_public_path__ + "images/carguide_cover.jpg";